export const GET_QUIZ = "GET_QUIZ";
export const NEXT_QUIZ = "NEXT_QUIZ";
export const PREVIOUS_QUIZ = "PREVIOUS_QUIZ";